import {Grid, Paper, TextField, Typography} from "@material-ui/core";
import TableESim from "../../../../../../ui/tables/table-e-sim/TableESim";
import {headCellsTextfield} from "./InviaDiNuovoEmailFirstStepHelper";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import EmptyRow from "../../../../../../ui/tables/rows/empty-row/EmptyRow";
import {useEffect} from "react";
import {validateEmail} from "../../../../../../../shared/utils/regexUtils";

const InviaDiNuovoEmailFirstStep = (props) => {

    const handleChange = (e, id) => {
        props.setNewTableData(props.tableData.map(item => {
            if (item.id === id) {
                return {...item, indirizzoEmail: e.target.value};
            }
            return item;
        }));
    }

    useEffect(() => {
        if (props.tableData.some((item) => !validateEmail(item.indirizzoEmail))) {
            props.setHasError(true);
        } else {
            props.setHasError(false);
        }
    }, [props.tableData])

    const tableRows = (
        props.tableData.length !== 0 ? props.tableData.map((row) => {
            return (
                <TableRow
                    hover tabIndex={-1}
                    key={"esim-selected-table-row-id" + row.id}>
                    <TableCell style={{border: '0.5px solid #e0e0e0'}}
                               align="left">{row.numeroDiTelefono ? row.numeroDiTelefono : row.seriale}</TableCell>
                    <TableCell style={{
                        border: '0.5px solid #e0e0e0',
                        color: row.esitoInvio === "Non riuscito" ? '#a3a1a1' : 'default'
                    }}
                               align="left">{row.esitoInvio}</TableCell>
                    <TableCell style={{
                        backgroundColor: "white",
                        border: '0.5px solid #e0e0e0',
                        borderBottom: !row.indirizzoEmail ? '0.5px solid red' : '0.5px solid #e0e0e0'
                    }}
                               align="left">
                        <TextField variant="standard"
                                   InputProps={{
                                       disableUnderline: true,
                                   }}
                                   value={row.indirizzoEmail}
                                   fullWidth
                                   multiline
                                   name={"indirizzoEmail"}
                                   onChange={(e) => handleChange(e, row.id)}
                                   placeholder="Inserisci email"/>
                    </TableCell>
                </TableRow>
            );
        }) : <EmptyRow text="dati" colSpan={headCellsTextfield.length}/>
    )

    return (
        <Paper elevation={1}>
            <Grid container style={{padding: '2em'}}>
                <Typography variant="body1">Per ciascuna eSIM selezionata, è possibile confermare o modificare
                    l'indirizzo email a cui verrà inviato il QR code.</Typography>

                <Grid item xs={12} style={{padding: '2em 0'}}>
                    <TableESim headCells={headCellsTextfield}
                               loading={false}
                               tableRows={tableRows}
                               showPagination={false}/>
                </Grid>

                {props.hasError ?
                    <Typography variant="body2" color={"error"} style={{marginBottom: '1em'}}>
                        Formato email non valido, controlla e correggi i campi evidenziati.
                    </Typography> : null}

                <Typography variant="body1"><b>ATTENZIONE</b>: Proseguendo confermerai le email e autorizzerai il
                    sistema
                    all’invio dei QR code agli indirizzi indicati</Typography>
            </Grid>
        </Paper>
    )
}

export default InviaDiNuovoEmailFirstStep;
